import { AxiosResponse } from "axios";
import { defaultFilterQuery } from ".";
import api from "../apiService";
import { MerchantQuery } from "../queries";
import { ApiResponse } from "types";
import { Customer } from "features/customer/types";
import { UserQuery } from "features/community/post/types";

export const getCustomersAPI = async (
	query: MerchantQuery = defaultFilterQuery,
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get("/dashboard/customers", {
				...query,
				skip: query.skip * (query.take || 10),
			});
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getCustomersInformationAPI = async (
	users?: UserQuery[],
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.post<ApiResponse<Customer[]>>(
				"/users/list",
				{
					users,
				},
			);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});

export const getCustomerByIdAPI = (id?: number) =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get(
				"/dashboard/customers/" + id,
			);
			resolve(response.data.data);
		} catch (err) {
			reject(err);
		}
	});
